import React, { useRef, useState } from "react"
import AsyncSelect from "react-select/async";
import {
  getPlaceholderForAutocompleteFieldConfiguration, hasBeenFilled,
  selectCustomStyles
} from "../../../../helpers/dynamicFormHelper";
import ApplicationService from "../../../../services/ApplicationService";
import {AutocompleteSearchFieldType, ConfigurationsType} from "../../../../types/configurations";
import { FormikProps } from "formik/dist/types";
import {FIRST_SEARCH_PAGE_NUMBER} from "../../../../helpers/searchHelper";
import { AppParametersType } from "../../../../types/app";

interface PropsType {
  configurations: ConfigurationsType,
  scopeConfigurationFields: string,
  fieldConfigurations: AutocompleteSearchFieldType,
  disabled: boolean,
  forceDisabled: boolean,
  changeFilterDispatchActionHandler: any,
  formProps: FormikProps<any>
  appParameters: AppParametersType
}

const AutocompleteSearchField = (props: PropsType) => {
  const {
    configurations,
    scopeConfigurationFields,
    fieldConfigurations,
    disabled,
    forceDisabled,
    changeFilterDispatchActionHandler,
    formProps: {
      values
    },
    appParameters
  } = props;

  const language = appParameters.language;

  const [isLoading, setIsLoading] = useState(false);

  const menuRef:any = useRef(null);

  const loadOptions = (inputValue, callback) => {
    // const { profile } = appParameters;
    // const [user_profile] = [profile].map((item) => (item && item.toString().split("_").pop()) || "");
    // @mapitaly: passo un user_profile statico TODO: da eliminare quando viene rimpiazzata la chiamata al servizio
    const user_profile = "MAPITALY";

    if (inputValue.length >= 2) {
      setIsLoading(true);
      ApplicationService.autocomplete({
        pageNumber: FIRST_SEARCH_PAGE_NUMBER,
        pageSize: 5,
        productCategory: configurations.productCategory,
        productName: configurations.productName,
        mission: values.missions[0],
        scope: scopeConfigurationFields,
        fieldName: fieldConfigurations.name,
        fieldValue: inputValue,
        profile: user_profile
      }).then((response) => {
        if (response.data && response.data.values && response.data.values.length > 0) {
          callback(response.data.values.map((val) => ({label: val, value: val})));
          if (menuRef) {
            menuRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          }
        }
        setIsLoading(false);
      });
    }
  };

  const value = values[fieldConfigurations.name];
  const isInputDisabled = forceDisabled || (disabled && hasBeenFilled(value));
  const isClearable = hasBeenFilled(value) && !isInputDisabled;

  return (
    <div
      ref={menuRef}
      role="button"
      aria-hidden="true"
      onClick={() => {
        if (menuRef) {
          menuRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
      }}
    >
      <AsyncSelect
        name={fieldConfigurations.name}
        styles={selectCustomStyles}
        loadOptions={loadOptions}
        isClearable={isClearable}
        disabled={isInputDisabled}
        placeholder={getPlaceholderForAutocompleteFieldConfiguration(fieldConfigurations, appParameters.language as string)}
        noOptionsMessage={({inputValue}) => {
          return (!!inputValue) ? "No Data Found" : "Type Something..."
        }}
        loadingMessage={({inputValue}) => {
          return (!inputValue && isLoading) ? "Loading..." : "No Options Found"
        }}
        isLoading={isLoading}
        onChange={(option) => {
          const newValue = option && option.value;
          changeFilterDispatchActionHandler(fieldConfigurations.name, newValue);
        }}
      />
    </div>
  );
};

export default AutocompleteSearchField;
